import React, { useContext } from 'react'
import { IoArrowForwardOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'
import { Images } from "constants";
import { UserContext } from 'context';
import { utils } from 'helper';

const UpgradeBar = ({ remainingDays, warningDetails }) => {
    const isFreePlan = warningDetails?.subscription_data?.plan_type === "Free Plan";
    
    const { setSubscriptionDetails } = useContext(UserContext)
console.log("remainingDays",remainingDays)
    const navigate = useNavigate()
    return (
        <>
            <div className='__subscr_planUp_bx'>
                {remainingDays != "" && <img src={Images.WARN_ICON.default} alt="" />}
                <div>
                    {remainingDays > 0 && (
                        <div>
                            <h6>
                                {/* You have Transport 360{" "} */}
                                <span style={{ color: "#06f" }}>
                                    {warningDetails?.subscription_data?.plan_type}
                                </span>
                                {!isFreePlan && (
                                    <>
                                        {" "}  expires in {remainingDays}{" "}
                                        {remainingDays === 1 ? "Day" : "Days"}
                                    </>
                                )}
                            </h6>

                        </div>
                        // <p style={{fontWeight:500, fontSize:"16px",color:"#000"}}>

                        // </p>
                    )}

                    {(remainingDays == 0) && (
                        <p style={{ color: "red" }}>
                            Your <strong>{warningDetails?.subscription_data?.plan_type}</strong>  Expired Today!
                        </p>
                    )}

                    {remainingDays < 0 && (
                        <p style={{ color: "red" }}>
                            <strong>{warningDetails?.subscription_data?.plan_type}</strong> Expired on {utils?.dd_mm_yy_formatDate(warningDetails?.web_end_date)}
                        </p>
                    )}

                </div>
                {remainingDays < 15 && <button
                    className={`anime-btn __upGrd_btn ${remainingDays > 0 ? "upgrade-btn" : "buy-btn"
                        }`}
                    onClick={() => {
                        setSubscriptionDetails(warningDetails?.subscription_data)
                        navigate(remainingDays > 0 ? "/subscription" : "/subscription/plan_detail")
                    }}
                >
                    {remainingDays > 0 ? "Upgrade Plan" : remainingDays < 0 ? "Renew" : "Buy Plan"}
                    <IoArrowForwardOutline />
                </button>}
            </div>
        </>
    )
}

export default UpgradeBar